/*
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-12 17:29:47
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-24 15:40:01
 * @FilePath: /privacy-web/src/router/index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store';
import Index from "views/index.vue";
import HomePage from "views/HomePage/index.vue";
import HomePage1 from "views/HomePage1/index.vue";
import PrivacyProtect from "views/PrivacyProtect/index.vue";
import PrivacyManage from "views/PrivacyManage/index.vue";
import PrivacyPolicy from "views/PrivacyPolicy/index.vue";
import PrivacyAttestation from "views/PrivacyAttestation/index.vue";
import PrivacyDsr from "views/PrivacyDsr/PrivacyDsr.vue";
import ProductSelection from "views/PrivacyDsr/ProductSelection.vue";
import ProblemType from "views/PrivacyDsr/ProblemType.vue";
import FeedbackRetention from "views/PrivacyDsr/FeedbackRetention.vue";
import PrivacyVerification from "views/PrivacyDsr/PrivacyVerification.vue";
import Document from "views/PrivacyPolicy/Document/index.vue";
import ChildProtectRule from "views/PrivacyPolicy/PolicyContent.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/",
    redirect: { name: "home-page-tile" },
  },
  {
    path: '/welcome',
    name: 'welcome'
  },
  {
    path: '/document',
    name: 'document',
    component: Document
  },
  {
    path: '/child-protect-rule',
    name: 'child-protect-rule',
    component: ChildProtectRule
  },
  {
    path: '/index',
    name: 'index',
    redirect: { name: "home-page" },
    // component: () =>
    //   import(/* webpackChunkName: "index" */ "views/index.vue"),
    component: Index,
    children: [
      {
        path: '/home-page',
        name: 'home-page',
        // component: () =>
        //   import(/* webpackChunkName: "homePage" */ "views/HomePage/index.vue"),
        component: HomePage
      },
      {
        path: '/home-page-tile',
        name: 'home-page-tile',
        // component: () =>
        //   import(/* webpackChunkName: "homePage1" */ "views/HomePage1/index.vue"),
        component: HomePage1
      },
      {
        path: '/privacy-protect',
        name: 'privacy-protect',
        // component: () =>
        //   import(/* webpackChunkName: "privacyProtect" */ "views/PrivacyProtect/index.vue"),
        component: PrivacyProtect
      },
      {
        path: '/privacy-manage',
        name: 'privacy-manage',
        // component: () =>
        //   import(/* webpackChunkName: "privacyManage" */ "views/PrivacyManage/index.vue"),
        component: PrivacyManage

      },
      {
        path: '/privacy-policy',
        name: 'privacy-policy',
        // component: () =>
        //   import(/* webpackChunkName: "privacyPolicy" */ "views/PrivacyPolicy/index.vue"),
        component: PrivacyPolicy
      },
      {
        path: '/privacy-attestation',
        name: '/privacy-attestation',
        // component: () =>
        //   import(/* webpackChunkName: "privacyAttestation" */ "views/PrivacyAttestation/index.vue"),
        component: PrivacyAttestation
      }
    ]
  },
  {
    path: '/dsr',
    name: 'dsr',
    redirect: { name: "dsr-product" },
    // component: () =>
    //   import(/* webpackChunkName: "privacyDsr" */ "views/PrivacyDsr/PrivacyDsr.vue"),
    component: PrivacyDsr,
    children: [
      {
        path: '/dsr/product',
        name: 'dsr-product',
        // component: () =>
        //   import(/* webpackChunkName: "ProductSelection" */ "views/PrivacyDsr/ProductSelection.vue"),
        component: ProductSelection
      },
      {
        path: '/dsr/type',
        name: 'dsr-type',
        // component: () =>
        //   import(/* webpackChunkName: "ProblemType" */ "views/PrivacyDsr/ProblemType.vue"),
        component: ProblemType
      },
      {
        path: '/dsr/capital-retention',
        name: 'dsr-capital-retention',
        // component: () =>
        //   import(/* webpackChunkName: "FeedbackRetention" */ "views/PrivacyDsr/FeedbackRetention.vue"),
        component: FeedbackRetention
      }
    ]
  },
  {
    path: '/verification',
    name: 'verification',
    // component: () =>
    //   import(/* webpackChunkName: "ProductSelection" */ "views/PrivacyDsr/PrivacyVerification.vue"),
    component: PrivacyVerification
  },
];
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});
const originalPush = VueRouter.prototype.push;
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
router.afterEach((to, from, next) => {
  window.my_track?.send(window.returnCitySN["cip"], 'viewPage', {
    path: to.path,
    city: window.returnCitySN["cname"],
    isMobile: window.isMobile,
    userAgent: navigator.userAgent
  });
  if (from.path === '/dsr/capital-retention' && to.path === '/privacy-manage') {
    store.dispatch('app/resetVuex');
  }
  document.querySelector('.el-main') && (document.querySelector('.el-main').scrollTop = 0);
});
export default router;
